/**
 * Rotating copy + timing while story Cloud Functions run (create + edit).
 * Keeps Share Your Story and Edit story saves visually consistent.
 */
export const STORY_WRITE_LOADING_MESSAGES = [
  'Holding space for your words...',
  'Discovering the themes in your journey...',
  'Weaving your story into the collection...',
  'Almost ready to share...',
];

export const STORY_WRITE_LOADING_INTERVAL_MS = 1400;

export const STORY_WRITE_LOADING_HINT =
  'First submit can take a little longer while services wake up.';

/**
 * Re-analyze flow rotates a separate set of messages — different action
 * (refining an existing story vs. writing a new one) and the timing
 * windows are usually shorter once the function is warm, but Gemini
 * cold-start still bites the first call.
 */
export const STORY_REANALYZE_LOADING_MESSAGES = [
  'Re-reading your story...',
  'Listening for themes you might have missed...',
  'Looking for a sharper highlight...',
  'Almost there...',
];

export const STORY_REANALYZE_LOADING_INTERVAL_MS = 1500;

export const STORY_REANALYZE_LOADING_HINT =
  'This can take a few seconds while Gemini warms up.';
